/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Contact_Languages_ValueInputs */

const es_privacy_policy_contact_languages_value = /** @type {(inputs: Privacy_Policy_Contact_Languages_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espanol e Ingles`)
};

const en_privacy_policy_contact_languages_value = /** @type {(inputs: Privacy_Policy_Contact_Languages_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spanish and English`)
};

/**
* | output |
* | --- |
* | "Spanish and English" |
*
* @param {Privacy_Policy_Contact_Languages_ValueInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_contact_languages_value = /** @type {((inputs?: Privacy_Policy_Contact_Languages_ValueInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Contact_Languages_ValueInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_contact_languages_value(inputs)
	return en_privacy_policy_contact_languages_value(inputs)
});
export { privacy_policy_contact_languages_value as "privacy_policy.contact.languages_value" }